import allSettings from "../data/accountSettingsData";

export default function accountSettingsValueToLabel(value) {
    let setting = allSettings.filter(item => {
        return item.value == value
    });
    return setting[0] ? setting[0].label : '';
}